var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarbohydrates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "carbohydrates") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "transparent_squares",
    "data-name": "transparent squares"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.46,
    y: 0.53,
    width: 1000,
    height: 1000,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "carbs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grains"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M169.47,324.1c36.85-11.91,1.05-89.52,1.05-89.52C131.05,296.9,169.47,324.1,169.47,324.1Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M207.58,299.33c13.86-18.1,15.79-29.37,15.14-40.51-.88-15.25-10.48-61.32-10.48-61.32C148,267.84,207.58,299.33,207.58,299.33Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M245.43,261.69c29-11.24,33-39.46,33-39.46l-5.9-60s-26.92,23.26-40.32,45.55S245.43,261.69,245.43,261.69Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M301.74,226.12c30.64-8.75,43.58-36.7,43.58-36.7,8.58-18.86,5.93-66,5.93-66C324.66,136.35,286.83,174,286.83,174,269.35,200.37,301.74,226.12,301.74,226.12Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M367.73,195.8c41-10.79,46.06-25.74,46.06-25.74L430.19,114,377,142.65C339,160.2,367.73,195.8,367.73,195.8Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M435.13,171.21c37.65.82,45.5-17.52,45.5-17.52l16.45-44L442,135.23C414.75,147.14,435.13,171.21,435.13,171.21Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M498.78,155.26c54.4-10.18,69.3-52.77,59.88-47.87s-45.82,17-45.82,17C485.32,135.77,498.78,155.26,498.78,155.26Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M181.2,330.84s6.84,32.43,91.71,18C272.91,348.85,205.11,305.28,181.2,330.84Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M263.79,298.06c-13.2-3-27.17-4-52,2.86,0,0,7,53.13,105.86,18.12C317.63,319,281.91,302.19,263.79,298.06Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M251.73,265.91S275.15,299,306.81,300.4s77.46-11.47,77.46-11.47L312.16,262S278.19,251.38,251.73,265.91Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M371.2,225.88s-37.79-7.11-64.22,7.57c0,0,10.49,34.74,49,38.12,0,0,70.35-2.1,99.17-11.9C455.2,259.67,396.64,230.78,371.2,225.88Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M372.82,201.12S386.8,241,431,234.53l75.43-7.11-75.65-31S412.61,188.25,372.82,201.12Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M444.07,179s6.1,23.44,38.59,23.21l83.39,1.5-71.2-26.61S474.72,164.26,444.07,179Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M505.53,162.47s2.48,16.13,35.33,20c0,0,48.66-.86,60.55,1.4S558.9,154,505.53,162.47Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M538.54,154.47c70.22,9.77,108.16-18.6,108.16-18.6C537.45,127.57,538.54,154.47,538.54,154.47Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M173.17,329s-49.41,32.12-71.79,135.34c0,0,7.4,10,12.55.27s-3.61-52.67,61.2-127C175.13,337.6,183.58,332.64,173.17,329Z",
    style: {
      fill: "#ffb600"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "grains-2",
    "data-name": "grains"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.6,700.53c-.18-.87-.35-1.67-.53-2.28-1.11-3.82-2.16-7.67-3-11.56-1.65-7.37-1.48-15.25-3.44-22.47-.56-2.05-3.67-2.91-4.52-.51-3.11,8.81,0,19.82,2.3,28.51.32,1.18.65,2.37,1,3.56-.8-1.3-1.58-2.62-2.28-4a71.12,71.12,0,0,1-4.56-10.44c-1.19-3.54-1.34-7.52-3-10.83a3,3,0,0,0-5.6.85c-1.57,7.25,3.66,17,7,23.14,3.84,7,8.37,14.43,14.45,19.69a1.81,1.81,0,0,0,1,.46c10.09,46.68,37,48.17,37,48.17C183.6,741.34,147.8,710.24,135.6,700.53Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,690.77c-5.1-7.41-19.22-23.67-27.32-32.87-.92-6.79-.25-14.24.08-20.6q.33-6.64,1-13.26c.47-4.57,1.64-9.41,1-14-.38-2.71-4-2.87-5.1-.57-2.05,4.44-2.11,9.94-2.56,14.76q-.75,8-1,16.11c-.09,2.79-.14,5.49-.07,8.12-.55-2.37-1.07-4.75-1.54-7.13-1.67-8.48-1.48-17.58-3.61-25.89a3,3,0,0,0-5.93.13c-1.51,8.82.88,19.1,2.7,27.75,1.72,8.2,3.65,18.36,8.57,25.28a2.35,2.35,0,0,0,.61.61C141.6,731.31,181,727.17,181,727.17,180.37,707.6,176.36,698.53,171,690.77Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.9,638.33l-24.52-33.09c.55-7.38,1.28-14.77,2.29-22.08q.92-6.67,2.11-13.33c.9-4.91,2.79-10.14,2.79-15.12a2.45,2.45,0,0,0-4.69-1.18c-2.16,4.09-2.71,9.23-3.61,13.75s-1.68,9.22-2.28,13.88v-.08c-.25-5.16-.36-10.33-.49-15.51s.58-11.2-.57-16.37c-.48-2.13-4-3.09-4.73-.54-1.3,4.82-.89,10.14-.9,15.11,0,5.45.2,10.9.5,16.34A200.93,200.93,0,0,0,153.73,606c-1,10.35-2.33,28.43-.51,43.39,2.72,22.39,31.44,32.9,31.44,32.9C195.42,660.62,184.9,638.33,184.9,638.33Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.62,583.4c-2.48-11.54-13-29.61-20-40.75,1.6-7.93,3.21-15.85,5-23.74q2.23-9.64,4.84-19.22c1.64-6,4.71-12.63,4.83-18.86,0-2.35-3.13-4.22-4.68-1.85-3.42,5.24-4.48,12.34-6.08,18.33q-2.53,9.45-4.71,19c-.61,2.63-1.18,5.25-1.73,7.89l.09-1.12c.72-8.85,3-18.61,2.19-27.44-.23-2.44-4-2.84-4.79-.54-2.83,8.34-2.59,18.58-3.27,27.31-.48,6.18-.74,12.31-.85,18.45-6.74,23.17-9.67,58.61-9.67,58.61,2.33,27.26,31.54,30.84,31.54,30.84C212.13,609.68,206.62,583.4,206.62,583.4Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.23,537.5l-8.82-26.19c.89-9.28,1.53-18.57,2.82-27.81,1.43-10.15,5.44-21.09,4.87-31.32-.1-1.88-3-2.52-4-1-5.45,8.48-6.47,20.7-7.78,30.62l-.06-2.23q-.27-7.72-.92-15.43c-.41-4.91-.35-10.43-2.32-15-1.1-2.56-4.85-1.84-5.23.8-.67,4.64.58,9.6,1,14.25q.72,7.68,1,15.41c.25,5.78.29,11.57.34,17.36l-13.37,37.79c-12.79,30.37,18.84,42.81,18.84,42.81C239.17,550.69,235.23,537.5,235.23,537.5Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.3,494.52l-7.61-27.83q2.71-10.92,5.44-21.82c2.29-9.14,6.73-19.12,6.67-28.59,0-1.63-2.18-3-3.29-1.3-5.2,7.89-6.61,18.83-8.87,27.91-1.07,4.29-2,8.58-2.94,12.88l-.22-.82L251.77,459c.38-4.48.62-9,.71-13.5.22-10.62.55-21.74-2.28-32-.57-2.06-3.9-2.42-4.08.09-.74,10.7.62,21.47.46,32.22-.15,9.95-.79,19.93-1.78,29.83l-9.86,23.51c-9.48,21.3,12.43,29.26,12.43,29.26C268.26,511.46,264.3,494.52,264.3,494.52Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.84,392.41c1.51-4.33,3.66-8.6,4.49-13.11a2,2,0,0,0-3.54-1.41c-2.51,3.82-3.77,8.49-5.24,12.8q-2.61,7.67-4.72,15.48c-.42,1.58-.85,3.17-1.26,4.76,0-1.54,0-3.07.07-4.58.2-9.15.44-18.22-1.48-27.21a1.29,1.29,0,0,0-2.55.05c-1.43,9.47-1,19-1.22,28.55-.19,8.16-1.19,16.53-.93,24.72-5.27,10.64-13.78,25.83-13.78,25.83-9.88,21.06,6.21,28.92,6.21,28.92,18-23.46,17.4-49.54,14.55-59.48,1.53-7.27,3-14.54,5.07-21.72Q296.49,399.16,298.84,392.41Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.23,731c-7.48-2.3-15.88-.36-23.15,1.9-1.17.36-2.47.78-3.82,1.25,2-2.29,4-4.52,6.09-6.64,5-5,10.66-9.17,15.81-14,1.54-1.44.1-4.4-2-3.35-10,4.94-18.61,13.5-25.57,22.67-14.74,1-50.6,5.85-51.83,29.39,0,0,14.69,16.3,46.35-16.25.37-.15.72-.34,1.09-.52a2.07,2.07,0,0,0,2.08-1l.21-.3c.82-.47,1.64-.94,2.48-1.36a70.3,70.3,0,0,1,10-4c7.19-2.29,14.71-2.2,21.91-4.11C266.47,734.32,267.27,731.65,265.23,731Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.2,683.92c-4.78-.65-10.1,1.31-14.67,2.62a135.64,135.64,0,0,0-14.19,4.87c-1.56.64-3.09,1.32-4.62,2,3.21-2.71,6.49-5.33,9.86-7.75a109.54,109.54,0,0,1,12.7-7.41c4.37-2.34,9-3.74,13.39-5.84a2,2,0,0,0-.57-3.72c-9.87-.86-20.07,4.61-27.9,10a97.64,97.64,0,0,0-14.28,12.31c-8.32,1.54-25.27,5-33.92,9s-16.6,9.73-27.05,26.29c0,0,23.45,29.85,56.92-21.1A151.64,151.64,0,0,1,258.81,697a123.11,123.11,0,0,1,13.52-4.37c4.42-1.15,9.59-1.37,13.68-3.44A2.79,2.79,0,0,0,285.2,683.92Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.42,625.91c-7.34-1.08-16.19,1.43-23.32,3.16A90,90,0,0,0,271,635.79c1.18-1.85,2.43-3.66,3.79-5.43a85.94,85.94,0,0,1,7.55-8.62c2.45-2.45,5.38-4.66,7.32-7.55a2.49,2.49,0,0,0-3-3.73c-6.8,2.77-12.59,10.45-16.92,16.14A84.57,84.57,0,0,0,261,640.52l-39.86,10.9s-23.27,8.14-31.16,31c0,0,27.64,13.1,45.5-.66,12.46-9.61,25.56-27.39,32.35-37.28a61.46,61.46,0,0,1,6.79-3.4,100,100,0,0,1,20-5.88c6.32-1.26,13.75-1.4,19.62-4.09A2.74,2.74,0,0,0,313.42,625.91Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,576.31c-7,.07-15.16,3.82-21.5,6.7l-.45.21.05-.08-1.72.25c1-1,2-1.94,3-2.92,5.51-5.41,13.07-10.91,17.05-17.55,1.09-1.82-.6-5.08-2.94-3.69-7.43,4.39-13.62,12.66-19.71,18.77-2.28,2.29-4.53,4.54-6.66,6.88-14.35,2.43-38.95,7.2-50,12.89,0,0-23.78,12.44-31.58,35.39,0,0,21.31,20.28,43.84,4.78,0,0,27.49-25.2,42.44-45.33a78.3,78.3,0,0,1,9.71-4.69c6.3-2.55,13.95-3.74,19.68-7.33C322.88,579.53,322,576.29,320,576.31Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.26,520.28c-5.33-1.58-11.87.21-17.15,1.51a100.69,100.69,0,0,0-37.13,18l-38.68,8.93s-13.54,2.55-29.44,30.41c0,0,25.55,22.41,46.7-2.88l22.49-23.9a2.08,2.08,0,0,0,1.55-.19A82.28,82.28,0,0,1,316,545.39c6.07-1.39,12.49-.87,18.44-2.28,1.92-.45,2.89-3.75.49-4.36-6.17-1.58-13.65,0-19.75,1.44A73.48,73.48,0,0,0,304,543.82l4.47-4.75a88.64,88.64,0,0,1,9.23-4.92,85.79,85.79,0,0,1,15.48-5.4c5.13-1.24,11.37-1.08,16.14-3.26C351.4,524.55,351.69,521,349.26,520.28Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.52,486.41c-9.33-1.55-20,.62-29,3-2.28.6-4.52,1.27-6.74,2l.56-.45-50.75,13.87s-16.71.09-26.81,25c0,0,13.86,14.15,31.46-1.14l27.9-22.85A107,107,0,0,1,331,504.3c5.65,0,11.34,1.56,16.92,1.28,2.73-.14,2.51-3.84.54-4.84-5.28-2.67-12.68-2.54-18.49-2.33-1,0-2,.09-3,.16a138.31,138.31,0,0,1,14.18-4.26c9.07-2.17,18.44-2.5,27.48-4.48A1.73,1.73,0,0,0,368.52,486.41Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.67,449.77c-5.25-.6-10.69,1.13-15.76,2.37q-7.83,1.94-15.56,4.24c-2.35.7-4.67,1.47-6.93,2.34-.5,0-1.06.06-1.65.12,2.68-2.52,5.36-5,8.14-7.36,6.2-5.19,13.5-9.72,18.9-15.75,1.4-1.56-.69-3.76-2.41-3-7.66,3.24-14.47,9.63-20.76,14.92-4.91,4.14-10.3,8.44-14.84,13.24-13.52,3.51-32.47,11.81-46,28.43,0,0,8.6,10.53,28.25-1.94,0,0,14.34-12.78,24.82-21,5.17-2.75,11-4.31,16.73-5.79,4.66-1.21,9.36-2.29,14.06-3.33s9.42-1.5,13.59-3.71A2,2,0,0,0,378.67,449.77Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.18,381.06c9.18-12.21,20.66-22.4,29.89-34.47,1.17-1.54-.82-3.1-2.27-2.2-12.83,8-23.08,21.4-32,33.37-7.78,10.42-15.12,21.63-20.55,33.55-52.35,39.81-41,56.81-41,56.81,27.72-16.64,40.77-38.61,46.51-51.95q7.35-8.26,15-16.22c5.86-6.11,13.29-11.88,18.19-18.76,1.59-2.23-1.13-4.45-3.24-3.14-7,4.35-13.07,12-18.61,18-2.52,2.74-4.95,5.55-7.35,8.4l0-.08A279,279,0,0,1,362.18,381.06Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36-2",
    "data-name": "path36",
    d: "M175.54,764.7S163.05,811,197.22,896.18c0,0,8.52,3.79,7-5.65S178.55,854.05,180.46,770C180.46,770,182.83,762.47,175.54,764.7Z",
    style: {
      fill: "#ffb600"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "porridge"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M585.05,667.15H419.24a27.29,27.29,0,0,1,6.52-22.66,1.31,1.31,0,0,1,.11-.12,27.41,27.41,0,0,1,21.86-9.06,27.43,27.43,0,0,1,33.44-26.81,28.48,28.48,0,0,1,.69-3C490.73,632.2,530.18,654.86,585.05,667.15Z",
    style: {
      fill: "#d8b593",
      fillOpacity: 0.74
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.12,667.15H585.05c-54.87-12.29-94.32-34.95-103.19-61.66a27.39,27.39,0,0,1,36.83-17.78,27.41,27.41,0,0,1,40.52-14.1,27.42,27.42,0,0,1,42.29-7.07,27.42,27.42,0,0,1,42.86.17,27.39,27.39,0,0,1,42.27,7.38A27.39,27.39,0,0,1,727,588.56a27.42,27.42,0,0,1,37.37,21.07,27.42,27.42,0,0,1,33.24,27.08,27.42,27.42,0,0,1,21.89,9.34,27.28,27.28,0,0,1,6.59,21.1Z",
    style: {
      fill: "#efd9bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.2,739.1c-5.67,34.77-17.86,65-31.8,90.27-41.84,17.08-91.53,27-144.83,27-149,0-269.71-77.31-269.71-172.68a112,112,0,0,1,1.22-16.52H842.46c13.93,0,25.41,8.51,25.87,19.25A258,258,0,0,1,865.2,739.1Z",
    style: {
      fill: "#ffaeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.4,829.37a343.8,343.8,0,0,1-39.63,56.71H450.09c-25.35-29.61-60.5-79.93-71.44-147a258.72,258.72,0,0,1-3.13-52.7c.47-10.74,12-19.25,25.88-19.25h18.68a112,112,0,0,0-1.22,16.52c0,95.37,120.76,172.68,269.71,172.68C741.87,856.35,791.56,846.45,833.4,829.37Z",
    style: {
      fill: "#ff7b82",
      fillOpacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.15,
    y: 886.08,
    width: 343.56,
    height: 8.36,
    style: {
      fill: "#ff7b82"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 824.05,
    cy: 733.4,
    rx: 21,
    ry: 43.22,
    style: {
      fill: "#ffd7dd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "potato"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M856.52,386.42c-3.24,29.82-49.11,53.83-117.16,83.64C668.18,487.62,565.63,492.2,515,430.18,507.45,421,486.36,395.11,489.4,363c3.19-33.58,31.67-62.07,70.37-82.87,28.44-8.76,58.67-13.62,87-13.62C753.94,266.51,861.79,337.71,856.52,386.42Z",
    style: {
      fill: "#d8b593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.36,470.06c-12.34,5.4-25.4,11-39.08,16.86-25.15,10.78-37.76,16.09-53.54,19.42-53.88,11.37-139.21,6.26-184.2-52.74-9.72-12.76-28.24-37-25.58-67.18,4.19-47.54,59-86.67,122.81-106.29-38.7,20.8-67.18,49.29-70.37,82.87-3,32.11,18.05,58,25.59,67.18C565.63,492.2,668.18,487.62,739.36,470.06Z",
    style: {
      fill: "#c69c79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.09,424.46c5.95,8,17.56,6.82,17.49,8.8-.08,2.52-19,10.16-26.94.36s3.68-26.73,5.89-26.29C574.14,407.64,570.64,417.09,576.09,424.46Z",
    style: {
      fill: "#c69c79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.28,325.87c1.45,9.9,12.26,14.3,11.26,16-1.26,2.18-21.56,0-23.92-12.4s15.87-21.83,17.61-20.4C510.5,310.13,502.94,316.8,504.28,325.87Z",
    style: {
      fill: "#c69c79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.29,319.66c-6.4,5-5.14,14.45-6.75,14.45-2,0-8.72-15.22-.93-21.91s21.85,2.32,21.54,4.14C646.93,317.65,639.16,315,633.29,319.66Z",
    style: {
      fill: "#c69c79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.53,386.89c.47,2.27,2.31,11.07-1.14,13.11-4.53,2.68-19.25-5.67-18.49-15.53.45-5.83,6.3-12,11.24-11.24C653.86,374.06,655.86,383.67,656.53,386.89Z",
    style: {
      fill: "#c69c79"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 678.19,
    cy: 434.75,
    r: 5.29,
    style: {
      fill: "#c69c79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.42,332.3c-.88,5.78-6.47,11-10,10-3.25-1-4.24-7.24-3.7-11.43.62-4.82,3.81-11,7.41-10.83S779.27,326.71,778.42,332.3Z",
    style: {
      fill: "#c69c79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.73,301.77c-.88,2-5.71,1.56-10.83,1.14-5.46-.45-11.13-.92-12-3.71-.9-2.95,3.75-8.11,8.83-8.83C583.57,289.25,591.09,298.75,589.73,301.77Z",
    style: {
      fill: "#c69c79"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbohydrates);
export default __webpack_public_path__ + "static/media/carbohydrates.531c77427a4d198e818c659800467aa7.svg";
export { ForwardRef as ReactComponent };